module.exports = __webpack_public_path__ + "static/assets/f5fcc1345184db59b4b308e50ef4992e.png";